module.exports = __webpack_public_path__ + "img/safe_tool_03.30cbc277.jpg";